class OrderCardForm {
    #orderForm = null;
    #radioKnownAccount = null;
    #radioOtherAccount = null;
    #radioDonate = null;

    #fieldIBAN = null;
    #fieldBank = null;
    #fieldAccountOwner = null;

    #fieldDonationTarget = null;
    #submitInput = null;
    #isActive = false;
    #isSubmitting = false;
    constructor() {
        this.#orderForm = document.querySelector('.powermail_form');
        if (!this.#orderForm) {
            this.#isActive = false;
            return;
        }

        this.#radioKnownAccount = this.#orderForm.querySelector('input[name="tx_powermail_pi1[field][konto]"][value="Bekanntes Konto"]');
        this.#radioOtherAccount = this.#orderForm.querySelector('input[name="tx_powermail_pi1[field][konto]"][value="Anderes Konto"]');
        this.#radioDonate = this.#orderForm.querySelector('input[name="tx_powermail_pi1[field][konto]"][value="Spenden"]');
        this.#fieldIBAN = this.#orderForm.querySelector('input[name="tx_powermail_pi1[field][iban]"]');
        this.#fieldBank = this.#orderForm.querySelector('input[name="tx_powermail_pi1[field][kreditinstitut]"]');
        this.#fieldAccountOwner = this.#orderForm.querySelector('input[name="tx_powermail_pi1[field][kontoinhaber]"]');
        this.#fieldDonationTarget = this.#orderForm.querySelector('select[name="tx_powermail_pi1[field][spendenan]"]');
        this.#submitInput = this.#orderForm.querySelector('input[type="submit"]');
        this.#isActive = this.#radioKnownAccount && this.#radioOtherAccount && this.#radioDonate && this.#fieldIBAN && 
            this.#fieldBank && this.#fieldAccountOwner && this.#fieldDonationTarget && this.#submitInput;
    }

    init() {
        if (!this.#isActive) {
            return;
        }
        this.#updateFields();
        this.#radioKnownAccount.addEventListener('change', () => {
            this.#updateFields();
        });
        this.#radioOtherAccount.addEventListener('change', () => {
            this.#updateFields();
        });
        this.#radioDonate.addEventListener('change', () => {
            this.#updateFields();
        });
        this.#avoidDoubleSubmit();
    }

    #avoidDoubleSubmit() {
        this.#orderForm.addEventListener('submit', (event) => {
            if (this.#isSubmitting) {
                event.preventDefault();
                return;
            }
            this.#isSubmitting = true;
            this.#submitInput.setAttribute('disabled', 'disabled');
        });
    }

    #updateFields() {
        if (this.#radioOtherAccount.checked) {
            this.#showAccountFields();
            this.#hideField(this.#fieldDonationTarget);
        }
        else if (this.#radioDonate.checked) {
            this.#hideAccountFields();
            this.#showField(this.#fieldDonationTarget);
        } else {
            this.#hideAccountFields();
            this.#hideField(this.#fieldDonationTarget);
        }
    }

    #hideAccountFields() {
        this.#hideField(this.#fieldIBAN);
        this.#hideField(this.#fieldBank);
        this.#hideField(this.#fieldAccountOwner, false);
    }

    #showAccountFields() {
        this.#showField(this.#fieldIBAN);
        this.#showField(this.#fieldBank);
        this.#showField(this.#fieldAccountOwner, false);
    }

    #hideField(field, unsetRequired = true) {
        if (unsetRequired) {
            field.required = false;
        }
        field.closest('div').classList.add('d-none');
    }

    #showField(field, setRequired = true) {
        if (setRequired) {
            field.required = true;
        }
        field.closest('div').classList.remove('d-none');
    }


}

export {OrderCardForm};